import { Toast } from "@bp/ui-components";
import * as Sentry from "@sentry/react";
import { Provider } from "urql";
import { AdminAuthProvider } from "./AdminAuthProvider";
import { AppLayoutProvider } from "./contexts/AppLayoutContext";
import { CrumbTitleProvider } from "./contexts/CrumbTitleContext";
import { DataLoader } from "./DataLoader";
import { RequireAdmin } from "./RequireAdmin";
import { RequireAuth } from "./RequireAuth";
import { urqlClient } from "./utils/urqlClient";

/**
 * The authenticated app layout, mounted as the router's parent route element
 * (mirrors planung-frontend's `App`). Sets up the auth provider + guards, the
 * urql and layout/crumb providers and Toast, then renders the visual shell
 * (`DataLoader`); pages render through the shell's `Outlet`.
 */
const AppWithoutSentry = () => (
  <AdminAuthProvider>
    <RequireAuth>
      <RequireAdmin>
        <Provider value={urqlClient}>
          <AppLayoutProvider>
            <CrumbTitleProvider>
              <DataLoader />
            </CrumbTitleProvider>
          </AppLayoutProvider>
        </Provider>
      </RequireAdmin>
      <Toast />
    </RequireAuth>
  </AdminAuthProvider>
);

export const App = Sentry.withProfiler(AppWithoutSentry);
